import HttpStatus from 'http-status';

export enum Errors {
  CONFLICT = HttpStatus.CONFLICT,
}

interface ErrorPayload {
  [key: string]: string;
}

export interface ErrorResponse {
  status: number;
  data: ErrorPayload;
}
